const timelineModules = document.querySelectorAll('.timeline-module');

// Update width
const updateMaxWidth = () => {
  const yearItem = document.querySelectorAll('.timeline-module__year-item');
  if (yearItem.length > 0) {
    const maxWidth = Math.max(...Array.from(yearItem).map((l) => l.offsetWidth));
    document.querySelector('.timeline-module__year')?.style.setProperty('--max-width', `${maxWidth + 10}px`);
  }
};

timelineModules.forEach((el) => {
  const debouncedWidthUpdate = debounce(updateMaxWidth, 150);

  window.addEventListener('resize', debouncedWidthUpdate);
  window.addEventListener('load', updateMaxWidth);

  // Slider Work
  const sliders = {
    year: el.querySelector('[data-slider="timeline-module__year"]'),
    title: el.querySelector('[data-slider="timeline-module__title"]'),
    content: el.querySelector('[data-slider="timeline-module__content"]'),
    image: el.querySelector('[data-slider="timeline-module__image"]'),
    navArrow: el.querySelectorAll('.timeline-module__nav-arrow'),
    parent: el.closest('.sc-timeline-module'),
  };

  const arrows = {
    next: el.querySelector('.arrow-right'),
    prev: el.querySelector('.arrow-left'),
  };

  const baseOptions = {
    spaceBetween: 24,
    allowTouchMove: true,
    watchOverflow: true,
    autoHeight: true,
    direction: 'horizontal',
    breakpoints: {
      768: { speed: 800, spaceBetween: 0, allowTouchMove: false, autoHeight: false, direction: 'vertical' },
    },
  };

  const yearSlider = new Swiper(sliders.year, {
    ...baseOptions,

    navigation: {
      nextEl: arrows.next,
      prevEl: arrows.prev,
    },
  });

  const contentSlider = new Swiper(sliders.content, {
    ...baseOptions,
    autoHeight: false,
    effect: 'fade',
    breakpoints: {
      768: { direction: 'horizontal' },
    },
    fadeEffect: {
      crossFade: true,
    },
  });

  const imageSlider = new Swiper(sliders.image, {
    ...baseOptions,
    effect: 'creative',
    creativeEffect: {
      prev: { translate: [0, 0, -1] },
      next: { translate: [0, '100%', 0] },
    },
  });

  yearSlider.on('slideChange', ({ realIndex }) => {
    contentSlider.slideTo(realIndex);
    imageSlider.slideTo(realIndex);
  });
});
